import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "fields", "enabledField", "offsetAmount", "offsetUnit", "offsetDirection", "repeatInterval", "repeatUnit"];
  static values = { defaults: Object };

  connect() {
    // Listen for task type changes on the form
    this.taskTypeSelect = document.querySelector('[name="task[taskable_type]"]');
    if (this.taskTypeSelect) {
      this.taskTypeSelect.addEventListener("change", this.handleTaskTypeChange.bind(this));
    }
  }

  disconnect() {
    if (this.taskTypeSelect) {
      this.taskTypeSelect.removeEventListener("change", this.handleTaskTypeChange.bind(this));
    }
  }

  toggle() {
    const isEnabled = this.toggleTarget.checked;

    if (isEnabled) {
      this.fieldsTarget.classList.remove("d-none");
    } else {
      this.fieldsTarget.classList.add("d-none");
    }

    // Update the hidden enabled field
    if (this.hasEnabledFieldTarget) {
      this.enabledFieldTarget.value = isEnabled;
    }
  }

  handleTaskTypeChange(event) {
    const taskType = event.target.value;
    const defaults = this.defaultsValue[taskType];

    if (defaults) {
      this.applyDefaults(defaults);
    }
  }

  applyDefaults(defaults) {
    if (this.hasOffsetAmountTarget && defaults.offset?.amount !== undefined) {
      this.offsetAmountTarget.value = defaults.offset.amount;
    }
    if (this.hasOffsetUnitTarget && defaults.offset?.unit) {
      this.offsetUnitTarget.value = defaults.offset.unit;
    }
    if (this.hasOffsetDirectionTarget && defaults.offset?.direction) {
      this.offsetDirectionTarget.value = defaults.offset.direction;
    }
    if (this.hasRepeatIntervalTarget && defaults.repeat?.interval !== undefined) {
      this.repeatIntervalTarget.value = defaults.repeat.interval;
    }
    if (this.hasRepeatUnitTarget && defaults.repeat?.unit) {
      this.repeatUnitTarget.value = defaults.repeat.unit;
    }
  }
}
